import { DropdownWithSearchOption } from "../../components/atomic/DropdownWithSearch/interface";
import { FieldConfig } from "../../components/composed/CommonForm/interface";
import { getUserRbacGroup } from "../../shared/utils/Global";
import { CommonButtonProps } from "./interface";

export const statusOrder = ["RECEIVED", "PENDING", "WAIVED"];

export const creditDecisionOptions = [
  { name: "RECEIVED", value: "0" },
  { name: "PENDING", value: "1" },
  { name: "WAIVED", value: "2" },
];

export enum Status {
  RECEIVED = "RECEIVED",
  WAIVED = "WAIVED",
  DELETED = "DELETED",
  APPROVED = "APPROVED",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
}

export const order = ["DELETED"];

export const statusStyles: any = {
  RECEIVED: {
    backgroundColor: "rgb(187 247 208)",
    color: "rgb(34 197 94)",
    label: "Received",
  },
  WAIVED: {
    backgroundColor: "rgb(243 244 246)",
    color: "rgb(107 114 128)",
    label: "Waived",
  },
  PENDING: {
    backgroundColor: "rgb(254 240 138)",
    color: "rgb(202 138 4)",
    label: "Pending",
  },
  DELETED: {
    backgroundColor: "rgb(255 255 255)",
    color: "rgb(107 114 128)",
    label: "Deleted",
  },
};

export const BASE_FIELDS = [
  "condition",
  "status",
  "authority",
  "workflows",
  "actions",
  "remarks",
  "resolverComment",
  "salesComment",
  "document",
];

export const MFL_LAP_FIELDS = [
  "conditionName",
  // "authorityName",
  "status",
  "actions",
  "remarks",
  "resolverComment",
  "salesComment",
  "document",
];

export const ADDITIONAL_FIELDS = [];

export const fieldConfigs: Record<string, FieldConfig> = {
  conditionName: {
    type: "input",
    name: "condition",
    label: "Condition",
    placeholder: "Enter Condition",
    validation: {
      required: "Condition is required",
      validate: (val: any) => Object.keys(val)?.length > 0,
    },
    requiredIcon: true,
    styles: {
      wrapper: "w-full",
    },
    style: {
      wrapper: {
        gridColumn: "1 / span 2",
      },
    },
    value: "",
    maxLen: 200,
  },
  condition: {
    type: "dropdown",
    name: "condition",
    label: "Condition",
    disabled: true,
    placeholder: "Enter Condition",
    validation: {
      required: "Condition is required",
      validate: (val: any) => Object.keys(val)?.length > 0,
    },
    requiredIcon: true,
    hasSearch: true,
    styles: {
      wrapper: "w-full",
    },
    style: {
      wrapper: {
        gridColumn: "1 / span 2",
      },
    },
  },
  authority: {
    type: "dropdown",
    name: "authority",
    label: "Authority",
    placeholder: "Select Authority",
    requiredIcon: false,
    hasSearch: false,
    styles: {
      wrapper: "w-full",
    },
    style: {
      wrapper: {
        gridColumn: "1",
      },
    },
  },
  // authorityName: {
  //   type: "dropdown",
  //   name: "authorityName",
  //   label: "Authority",
  //   placeholder: "Select Authority",
  //   requiredIcon: false,
  //   hasSearch: false,
  //   styles: {
  //     wrapper: "w-full",
  //   },
  //   style: {
  //     wrapper: {
  //       gridColumn: "1 / span 2",
  //     },
  //   },
  // },
  workflows: {
    type: "dropdown",
    name: "workflows",
    label: "Workflows",
    placeholder: "Select Workflow",
    requiredIcon: false,
    hasSearch: false,
    styles: {
      wrapper: "w-full",
    },
    style: {
      wrapper: {
        gridColumn: "2",
      },
    },
  },
  remarks: {
    type: "input",
    inputType: "textarea",
    name: "remarks",
    label: "Remarks",
    requiredIcon: false,
    multiple: true,
    maxLen: 2500,
    styles: {
      wrapper: "w-full",
      textarea: "!border-gray-400",
    },
    style: {
      wrapper: {
        gridColumn: "1 / span 2",
      },
    },
  },
  document: {
    type: "file",
    name: "document",
    label: "Document",
    validation: { required: false },
    requiredIcon: false,
    styles: {
      inputContainer: "bg-white !h-[130px] !min-h-[130px] !border-solid",
      wrapper: "w-full grid grid-rows-1 gap-3",
      fileIcon: {
        wrapper: "bg-gray-100 flex flex-col border rounded-xl px-2 gap-2",
        container: " !p-4 w-full border-0 bg-white ",
      },
    },
    style: {
      wrapper: {
        gridColumn: "1 / span 2",
      },
    },
    outsideView: true,
    accept: {
      "application/pdf": [".pdf"],
      "image/*": [".jpeg", ".png", ".jpg"],
    },
    maxFiles: 5,
    multiple: true,
    showComment: true,
    commentFieldName: "comment",
  },
};

export const fieldConfigs1: Record<string, FieldConfig> = {
  ...fieldConfigs,
  condition: {
    ...fieldConfigs.condition,
    disabled: false,
  },
  workflows: {
    ...fieldConfigs?.workflows,
    requiredIcon: true,
    validation: {
      required: "Workflow is required",
      validate: (val: any) => Object.keys(val)?.length > 0,
    },
  },
  remarks: {
    ...fieldConfigs?.remarks,
    requiredIcon: true,
    validation: { required: "Remarks is required" },
  },
  authority: {
    type: "dropdown",
    name: "authority",
    label: "Authority",
    placeholder: "Select Authority",
    validation: {
      required: "Authority is required",
      validate: (val: any) => Object.keys(val)?.length > 0,
    },
    requiredIcon: true,
    hasSearch: false,
    styles: {
      wrapper: "w-full",
    },
    style: {
      wrapper: {
        gridColumn: "1",
      },
    },
  },
};

export const sendWorkflow = {
  type: "dropdown",
  name: "actions",
  label: "Actions",
  placeholder: "Select Actions",
  hasSearch: false,
  requiredIcon: false,
  validation: {
    required: "Authority is required",
    validate: (val: any) => Object.keys(val)?.length > 0,
  },
  styles: {
    wrapper: "w-full",
  },
  style: {
    wrapper: {
      gridColumn: "1",
    },
  },
};

export const buttonArrayProps: CommonButtonProps = {
  Reset: {
    className:
      "text-sm mr-4 px-4 py-2 w-auto rounded-lg bg-white !border !border-solid !border-gray-300 text-gray-700 flex items-center justify-center font-medium",
    label: "Reset",
    color: "default",
    type: "reset",
    isDisabled: false,
  },
  Submit: {
    type: "submit",
    color: "primary",
    label: "Submit",
    isDisabled: false,
    isVisible: true,
  },
  Update: {
    type: "submit",
    color: "primary",
    label: "Update",
    isDisabled: false,
  },
};

export enum ViewType {
  EXPANDED = "expanded",
  COLLAPSED = "collapsed",
}

export const DOC_STATUS = [
  "Document marked as Sampled Positive",
  "Document marked as screened",
  "Document marked as Sampled Refer",
];

export const authorityOptions: DropdownWithSearchOption<string>[] = [
  { name: "CM", value: "Credit L1" },
  { name: "ACM", value: "Credit L2" },
  { name: "State credit Manager", value: "Credit L3" },
  { name: "Circle Credit Manager", value: "Credit L4" },
  { name: "NCM", value: "Credit L5" },
  { name: "HCU", value: "Credit L6" },
  { name: "CCO", value: "Credit L7" },
];

export const authorityOptionsPL: DropdownWithSearchOption<string>[] = [
  { name: getUserRbacGroup(), value: getUserRbacGroup() },
];

export const authorityOptionsMFL: DropdownWithSearchOption<string>[] = [
  { name: "CM", value: "Credit L1" },
];

export const mapWorkflowItem = (data: any) => {
  return data.map((timelineItem: any) => {
    return {
      title: timelineItem.action,
      date: timelineItem.updatedAt,
      updatedBy: timelineItem.actionBy,
      comments: timelineItem.remarks,
      assignedUser: timelineItem.assignedTo,
      assignedUsername: timelineItem.assignedUsername,
      additionalParams: timelineItem.additionalParams,
    } as any;
  });
};

export const COLUMNS = [
  {
    key: "slno",
    name: "No",
    showInMobile: true,
    width: "40px",
    rowStyles: "!text-black content-start relative",
    headerStyles: "!text-gray-500 !font-normal z-10",
  },
  {
    key: "condition",
    name: "Condition",
    showInMobile: true,
    width: "180px",
    rowStyles: "!text-black content-start relative",
    headerStyles: "!text-gray-500 !font-normal z-10",
  },
  {
    key: "document",
    name: "Document",
    showInMobile: true,
    width: "180px",
    rowStyles: "!text-black content-start relative text-center",
    headerStyles: "!text-gray-500 !font-normal z-10 text-center",
  },
  {
    key: "assigned_user_group",
    name: "Assigned User Group",
    showInMobile: true,
    width: "120px",
    rowStyles: "!text-black content-start relative",
    headerStyles: "!text-gray-500 !font-normal z-10",
  },
  {
    key: "assigned_to",
    name: "Assigned To",
    showInMobile: true,
    width: "120px",
    rowStyles: "!text-black content-start relative",
    headerStyles: "!text-gray-500 !font-normal z-10",
  },
  {
    key: "workflow_current_state",
    name: "Current Assignee",
    showInMobile: true,
    width: "120px",
    rowStyles: "!text-black content-start relative",
    headerStyles: "!text-gray-500 !font-normal z-10",
  },
  {
    key: "created_at",
    name: "Raised Date",
    showInMobile: true,
    width: "120px",
    rowStyles: "!text-black content-start relative",
    headerStyles: "!text-gray-500 !font-normal z-10",
  },
  {
    key: "created_by",
    name: "Raised By(Email)",
    showInMobile: true,
    width: "180px",
    rowStyles: "!text-black content-start relative",
    headerStyles: "!text-gray-500 !font-normal z-10",
  },
  {
    key: "updated_at",
    name: "Resolved Date",
    showInMobile: true,
    width: "120px",
    rowStyles: "!text-black content-start relative text-center",
    headerStyles: "!text-gray-500 !font-normal z-10 text-center",
  },
  {
    key: "updated_by",
    name: "Resolved By(Email)",
    showInMobile: true,
    width: "180px",
    rowStyles: "!text-black content-start relative",
    headerStyles: "!text-gray-500 !font-normal z-10",
  },
  {
    key: "authority",
    name: "Authority",
    showInMobile: true,
    width: "120px",
    rowStyles: "!text-black content-start relative",
    headerStyles: "!text-gray-500 !font-normal z-10",
  },
  {
    key: "actions",
    name: "Actions",
    showInMobile: true,
    width: "80px",
    headerStyles: "sticky right-0 !text-gray-500 !font-normal z-20",
    rowStyles:
      "!overflow-visible sticky right-0 bg-white !text-black content-start",
    zIndex: 10,
  },
];

export const SANCATION_USERS = [
  { name: "Credit", value: "PL_Sanctions" },
  { name: "RCU", value: "PL_Sanctions_RCU" },
];
